import { format, lastDayOfMonth, parse } from "date-fns";
import { DEFAULT_VOC_PARAMETERS, VOC_DATE_FILTER_OPTIONS } from "../constants";
import { fetchDataV2, newApiFetchV2 } from "./utils";

export const getParams = () => {
  const params = window.location.search;
  const parameters = new URLSearchParams(params);

  const dateRangeParam = parameters.get("date_range");
  const brand = parameters.get("brand") == "All" ? [] : parameters.get("brand")?.split(",") ?? [];
  const market = parameters.get("market") == "All" ? [] : parameters.get("market")?.split(",") ?? [];
  const dealer = parameters.get("dealer") == "All" ? [] : parameters.get("dealer")?.split(",") ?? [];
  const model = parameters.get("model") == "All" ? [] : parameters.get("model")?.split(",") ?? [];
  const model_type = parameters.get("model_type") == "All" ? [] : parameters.get("model_type")?.split(",") ?? [];

  // Falls back to the filters component's own default date range (rather than "") so a request
  // that fires before that component's default-params effect has hydrated Redux/the URL - e.g.
  // right after navigating in from /dashboards - still sends a value the backend's date_range
  // enum accepts, instead of "" (which 422s).
  const date = dateRangeParam
    ? VOC_DATE_FILTER_OPTIONS.includes(dateRangeParam)
      ? dateRangeParam.split(" ").join("_").toLocaleLowerCase()
      : "custom"
    : DEFAULT_VOC_PARAMETERS.date_range.split(" ").join("_").toLocaleLowerCase();

  const parameterEntries: Record<string, string | null | Array<string> | undefined> = {
    date_range: date,
    brand: brand,
    market: market,
    dealer: dealer,
    model: model,
    vehicle_type: model_type,
  };

  if (date == "custom") {
    parameterEntries["start_date"] = dateRangeParam
      ? format(parse(dateRangeParam.split("-")[0].trim(), "MMMM yyyy", new Date()), "y-MM-dd")
      : "";
    parameterEntries["end_date"] = dateRangeParam
      ? format(lastDayOfMonth(parse(dateRangeParam.split("-")[1].trim(), "MMMM yyyy", new Date())), "y-MM-dd")
      : "";
  }

  return parameterEntries;
};

export const getQuickVocSalesFilters = () => newApiFetchV2("/quick-voc-sales/filters", getParams());

export const getQuickVocSalesLastRefreshDate = () => newApiFetchV2("/quick-voc-sales/last-refresh-date", getParams());

export const getPerformanceByMarketMap = () => newApiFetchV2(`/quick-voc-sales/performance-by-market`, getParams());

export const getMarketDeepDiveTable = () => newApiFetchV2(`/quick-voc-sales/market-deep-dive-table`, getParams());

export const getMarketDeepDiveTrendline = () => newApiFetchV2(`/quick-voc-sales/satisfaction-score-by-market`, getParams());

export const getDealerDeepDiveTable = (filterBy?: string) =>
  newApiFetchV2(`/quick-voc-sales/dealer-deep-dive-table?filter_by=${filterBy}`, getParams());

export const getDealerOverallPerformanceTrend = (filterBy?: string) =>
  newApiFetchV2(`/quick-voc-sales/satisfaction-score-by-dealer?filter_by=${filterBy}`, getParams());

export const getDealerScoreDistribution = (filterBy?: string) =>
  newApiFetchV2(`/quick-voc-sales/dealer-score-distribution?filter_by=${filterBy}`, getParams());

export const getModelDeepDiveTable = (filterBy?: string) =>
  newApiFetchV2(`/quick-voc-sales/model-deep-dive-table?filter_by=${filterBy}`, getParams());

export const getModelOverallPerformanceTrend = (filterBy?: string) =>
  newApiFetchV2(`/quick-voc-sales/satisfaction-score-by-model?filter_by=${filterBy}`, getParams());

export const getModelScoreDistribution = (filterBy?: string) =>
  newApiFetchV2(`/quick-voc-sales/model-score-distribution?filter_by=${filterBy}`, getParams());

export const getModelTypeDeepDiveTable = () => newApiFetchV2(`/quick-voc-sales/model-type-deep-dive-table`, getParams());

export const getModelTypeOverallPerformanceTrend = () => newApiFetchV2(`/quick-voc-sales/satisfaction-score-by-model-type`, getParams());

export const getModelTypeScoreDistribution = () => newApiFetchV2(`/quick-voc-sales/model-type-score-distribution`, getParams());

export const getVocQuickSalesTopicClassificationDissatisfaction = () =>
  newApiFetchV2("/quick-voc-sales/categories/topic-classification-dissatisfaction", { ...getParams() });
export const getVocQuickSalesTopicClassificationSatisfaction = () =>
  newApiFetchV2("/quick-voc-sales/categories/topic-classification-satisfaction", { ...getParams() });
export const getVocQuickSalesFeedbackComments = (google_rating: any, topics: any, touchpoints: any) =>
  newApiFetchV2("/quick-voc-sales/categories/feedback-comments", { ...getParams(), google_rating, topics, touchpoints });
export const getVocQuickSalesFeedbackCommentsFilters = () =>
  newApiFetchV2("/quick-voc-sales/categories/feedback-comments-filters", { ...getParams() });
